import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const DELETE_CLASS = gql`
  mutation DeleteClass($schoolClassID: Int!) {
    removeSchoolClass(schoolClassID: $schoolClassID) {
      type,
      message
    }
  }
`;
